module.exports = __webpack_public_path__ + "static/media/icon_e.5e2c7f77.svg";